"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
exports.default = new Network_1.default('kaia-test', [
    new Token_1.default('kaia', 'KAIA', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} KAIA', 'icon/kaia.svg'),
    new Token_1.default('oether', 'oETH', 'bifi', 1, '0xA3D1a0dD475e6f6334BC700890c13cE75BA5d72d', '', false, true, false, [], '{} oETH', 'icon/oeth.svg'),
    new Token_1.default('ousdt', 'oUSDT', 'bifi', 2, '0x012E3181f5fFDF7B28FaE62bb700FFE6ee922558', '', false, true, false, [], '{} oUSDT', 'icon/ousdt.svg'),
    new Token_1.default('kdai', 'kDAI', 'bifi', 3, '0x164Ad7FA912d09b58575500d0B4f8842b3697979', '', false, true, false, [], '{} kDAI', 'icon/kdai.png'),
    new Token_1.default('ousdc', 'oUSDC', 'bifi', 4, '0xb336CfD59DaB22fa54Ea31270a60Cd2D1a74B031', '', false, true, false, [], '{} oUSDC', 'icon/ousdc.png'),
    new Token_1.default('owbtc', 'oWBTC', 'bifi', 5, '0x81faa97e99B76CD4dDb692955277960c8EeFBDD8', '', false, true, false, [], '{} oWBTC', 'icon/owbtc.svg'),
    new Token_1.default('oxrp', 'oXRP', 'bifi', 6, '0x6F67AeEb3783963EFE20ccd0f8F0194604C44853', '', false, true, false, [], '{} oXRP', 'icon/oxrp.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0xA8D0c5d641f054550ae146a3FC602cDbc19D501D', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'kaia'),
    new Handler_1.default(1, 'oether'),
    new Handler_1.default(2, 'ousdt'),
    new Handler_1.default(3, 'kdai'),
    new Handler_1.default(4, 'ousdc'),
    new Handler_1.default(5, 'owbtc'),
    new Handler_1.default(6, 'oxrp')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('bifi.getOraclePeriodDelta', 'callProxyOracle_getPeriodDelta()', [], [
        '(uint256,uint256,uint256,int256,bool)[]',
        'bool'
    ]),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionNFT(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x0AC45e945A008D3fc19da8f591be8601C1F63130'),
    new EntryPoint_1.default('xBifi', '0xEc90b93aD873e7fe5f6461A796884029Ce434C6D'),
    new EntryPoint_1.default('xBifi.factory', '0xF25077F596DA7333E9F1aebC2cc2AB955A1d58EC')
], 3000);
//# sourceMappingURL=kaia-test.js.map